import { RefreshCw } from "lucide-react";
import { useAgentData } from "@/lib/agent";
import { AgentButton, Notice, Loading } from "@/components/agent/AgentUI";
import { WhatsAppConfig } from "@/components/agent/WhatsAppConfig";
import { WhatsAppSend } from "@/components/agent/WhatsAppSend";
import { WhatsAppHistory } from "@/components/agent/WhatsAppHistory";

export default function WhatsApp() {
  const { data, error, setError, load } = useAgentData("/whatsapp");
  const contacts = useAgentData("/contacts");
  return <div data-testid="agent-whatsapp-page">
    <div className="ag-section-heading"><div><h2>Conexión con WhatsApp</h2><p data-testid="whatsapp-provider">Twilio · Número aprobado</p></div>
      <AgentButton secondary onClick={load} data-testid="whatsapp-refresh"><RefreshCw size={16} />Actualizar estado</AgentButton>
    </div>
    <Notice error id="whatsapp-page-error">{error || contacts.error}</Notice>
    {!data ? <Loading /> : <>
      <Notice id="whatsapp-configuration-notice">{!data.configured
        ? "La configuración de Twilio está pendiente o no es válida. No se simulan envíos."
        : data.verification?.message || "Credenciales presentes. La cuenta y el remitente aún no se han verificado con Twilio."}</Notice>
      <div className="ag-whatsapp-layout">
        <WhatsAppConfig data={data} load={load} setError={setError} />
        <WhatsAppSend data={data} contacts={contacts.data || []} load={load} setError={setError} />
      </div>
      <WhatsAppHistory data={data} load={load} setError={setError} />
    </>}
  </div>;
}